import React from "react";
import "./css/TitleBox.scss";

const TitleBox = ({ title }) => {
  return <div className='title-box'>{title}</div>;
};

export default TitleBox;
